import React from 'react';
import {CSSTransition, TransitionGroup} from 'react-transition-group';
import {ANIMATION_TIMEOUT_INOUT} from '../../../../constants/animation';
import PersonConnectBlock from '../PersonConnectBlock';
import './styles.css';

const PeopleGrid = props => {
  const { records, onConnectHandler } = props;

  return (
    <div className="people-grid">
      <TransitionGroup component={null}>
        {records.map(record => {
          return (
            <CSSTransition
              classNames="item"
              timeout={ANIMATION_TIMEOUT_INOUT}
              key={record.CandidateID}
            >
              <div className="people-grid__item">
                <PersonConnectBlock
                  item={record}
                  onConnectHandler={onConnectHandler}
                />
              </div>
            </CSSTransition>
          );
        })}
      </TransitionGroup>
    </div>
  );
};

export default PeopleGrid;
